<template>
<div class="chapter">
<div class="inner_page">
<p class="h2" id="p15"><span><a href="#/Contents#rp15">ROASTED VEGETABLE STOCK</a></span></p>
<p class="imagel"><span><img alt="" height="5" src="images/line-3.jpg" width="532"/></span></p>
<p class="normal"><span><i>Roasting vegetables intensifies their flavors, adding richness to the stock. The beet adds a subtle sweetness to the stock, but use only if you don’t object to the pink color it creates!</i></span></p>
<p class="make"><span>Makes about 2 quarts</span></p>
<p class="hang"><span>1 each: coarsely chopped medium onion, leek (white part only), carrot, zucchini, turnip, beet, tomato</span></p>
<p class="hang"><span>½ small butternut or acorn squash, sliced (2-inch)</span></p>
<p class="hang"><span>1 bulb garlic, cut crosswise in half</span></p>
<p class="hang"><span>8 cups water</span></p>
<p class="hang"><span>1 cup dry white wine or water</span></p>
<p class="hang"><span>3 cups coarsely chopped kale</span></p>
<p class="hang"><span>6 sprigs parsley</span></p>
<p class="hang"><span>1 bay leaf</span></p>
<p class="hang"><span>1–2 teaspoons dried bouquet garni</span></p>
<p class="hang"><span>1 teaspoon black peppercorns</span></p>
<p class="hang"><span>4 whole allspice</span></p>
<p class="hang"><span>Salt and pepper, to taste</span></p>
<p class="normalt"><span><b>1.</b> Arrange vegetables, except kale, in single layer on greased, foil-lined jelly-roll pan; bake at 425 degrees until tender and browned, 35 to 40 minutes. Transfer vegetables to Dutch oven; add remaining ingredients, except salt and pepper, and heat to boiling. Reduce heat and simmer, covered, 1½ to 2 hours. Strain, discarding vegetables and seasonings; season to taste with salt and pepper.</span></p>
<p class="per"><span>Per Cup:</span></p>
<p class="per1"><span>Calories: 25</span></p>
<p class="per1"><span>% calories from fat: 1</span></p>
<p class="per1"><span>Protein (g): 0.2</span></p>
<p class="per1"><span>Carbohydrate (g): 1.5</span></p>
<p class="per1"><span>Fat (g): 0</span></p>
<p class="per1"><span>Saturated fat (g): 0</span></p>
<p class="per1"><span>Cholesterol (mg): 0</span></p>
<p class="per1"><span>Sodium (mg): 12</span></p>
<p class="per"><span>Exchanges:</span></p>
<p class="per1"><span>Milk: 0.0</span></p>
<p class="per1"><span>Vegetable: 0.0</span></p>
<p class="per1"><span>Fruit: 0.0</span></p>
<p class="per1"><span>Bread: 0.0</span></p>
<p class="per1"><span>Meat: 0.0</span></p>
<p class="per1"><span>Fat: 0.0</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Chapter0115.vue?16b906ec